/**
 * 무기 데이터. 장비 슬롯 전체는 M5 이고, M2 는 무기만 바꿔 끼울 수 있다.
 * 수치는 `weapons.json`.
 */

import seed from './weapons.json';
import { emitDataReloadSoon, replaceRecord, requireRecord } from './catalog';

export type WeaponKind = 'sword1h' | 'sword2h' | 'dagger' | 'wand' | 'bow';

export interface WeaponDef {
  id: string;
  name: string;
  kind: WeaponKind;
  watkMin: number;
  watkMax: number;
  speed: number;
  range: number;
  accuracy: number;
  itemId: string;
  description: string;
}

export let STARTER_WEAPON_ID = seed.STARTER_WEAPON_ID;

export const WEAPONS: Record<string, WeaponDef> = structuredClone(seed.WEAPONS) as Record<
  string,
  WeaponDef
>;

export function applyWeapons(raw: unknown): void {
  const data = requireRecord(raw, 'weapons.json');
  if (typeof data.STARTER_WEAPON_ID !== 'string') {
    throw new Error('weapons.json: STARTER_WEAPON_ID 가 없습니다');
  }
  STARTER_WEAPON_ID = data.STARTER_WEAPON_ID;
  replaceRecord(WEAPONS, structuredClone(requireRecord(data.WEAPONS, 'WEAPONS')) as Record<string, WeaponDef>);
}

export function getWeapon(id: string | undefined): WeaponDef {
  return WEAPONS[id ?? STARTER_WEAPON_ID] ?? WEAPONS[STARTER_WEAPON_ID];
}

export function weaponSpeedLabel(speed: number): string {
  if (speed <= 0.9) return '빠름';
  if (speed <= 1.08) return '보통';
  return '느림';
}

if (import.meta.hot) {
  import.meta.hot.accept('./weapons.json', (mod) => {
    if (!mod?.default) return;
    applyWeapons(mod.default);
    emitDataReloadSoon();
  });
}
